<list
  [listItems]="customListValues$ | async"
  [directoryTitle]="selectedDirectory?.title"
  [maxTitleLength]="1000"
  (save)="onSave($event)"
  (return)="return.emit()"
  (removeItem)="removeItem($event)"
></list>
